import { createSelector } from "reselect";

const selectAuthSlice = (state) => state.auth;

export const getIsLogged = createSelector(
  selectAuthSlice,
  (auth) => auth.isLogged,
);
